/**
 * Electron 환경 감지 및 관련 유틸리티입니다.
 *
 * 주요 기능:
 * - Electron 환경 여부 감지 (checkIsElectron)
 * - 외부 URL 열기 (openWindow)
 *
 * @remarks
 * Electron 앱과 웹 브라우저 환경에서 다른 동작이 필요할 때 사용합니다.
 */

/**
 * 현재 환경이 Electron인지 확인합니다.
 * @returns Electron 환경이면 true
 */
export function checkIsElectron() {
  // return navigator.userAgent.toLowerCase().includes(' electron/');
  return typeof window !== 'undefined' && window.electronAPI !== undefined;
}

export const isElectron = checkIsElectron();

export function openWindow(url: string) {
  if (isElectron) {
    window.electronAPI.send('openExternal', url);
  } else {
    window.open(url, '_blank');
  }
}
